import Header from '../Header/Header'
import React, { useCallback, useEffect, useState } from 'react'
import './index.css';
import { useDispatch, useSelector } from 'react-redux';
import userDetails from '../rtk-apis/user/userDetails';
import { AppDispatch, RootState } from '../store/store';
import { useNavigate } from 'react-router-dom';
import { ICONS } from '@ohif/ui';
import { capitalizeWords, customStyle, formatDate, formatDays, formatTime, getCurrencyContact } from '@custom/Utils/utils';
import { UserDataDetails } from '@custom/Utils/constants/interfaces';
import { SignatureDropzone } from '@custom/Profile';
import updateProfileImage from '@custom/rtk-apis/report/updateProfileImage';
import getBillingGeneralSettings from '@custom/rtk-apis/billing/getGeneralSettings';
import { _roleType } from '@custom/Utils/constants/appConstants';
import { useTheme } from "../../ui/src/contextProviders"

const UserDetails = () => {
    const isDarkMode = useTheme();
    const navigate = useNavigate();
    const [userData, setUserData] = useState<UserDataDetails>({});
    const hospitalName = sessionStorage.getItem('hospitalName') || localStorage.getItem('hospitalName');
    const role = sessionStorage.getItem('role') || localStorage.getItem('role');
    const [selectedCountryCode, setSelectedCountryCode] = useState<string>('+91');

    const dispatch = useDispatch<AppDispatch>();
    const data = useSelector((state: RootState) => state?.getUserDetails);
    const billingGeneralSettingsData = useSelector((state: RootState) => state.getBillingGeneralSettingsSliceResponse);

    useEffect(() => {
        dispatch(userDetails())
        dispatch(getBillingGeneralSettings());
    }, [dispatch])

    useEffect(() => {
        setUserData(data?.result)
    }, [data])

    const handleEdit = () => {
        navigate('/profile', { state: { userDetail: userData } })
    }

    const uploadSignatureFile = (file) => {
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('folderName', "signature");
                dispatch(updateProfileImage(formData))
                    .unwrap()
                    .then((result) => {
                        console.log('File uploaded successfully:', result);
                    })
                    .catch((error) => {
                        console.error('Error uploading file:', error);
                    });
            };
            reader.readAsDataURL(file);
        }
    }

    const onDrop = useCallback((acceptedFiles, setFieldValue) => {
        const file = acceptedFiles[0];
        uploadSignatureFile(file)
    }, []);

    const defaultCountryCode = billingGeneralSettingsData?.status && billingGeneralSettingsData?.result?.currency ? getCurrencyContact(billingGeneralSettingsData.result.currency) : '+91';

    return (
        <>
            <div className='page page__full' style={ isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground }>
                <Header title="My Profile" isBack={false}></Header>
                <div className='page__body'>
                    <div className='details'>
                        <div className='form form--innersec'>
                            <section className='form__section'>
                                <h1 className='form__section__title'> User Details
                                    <button className="btn btn__primary" onClick={handleEdit}>
                                        <img src={ICONS["edit"]} alt="edit" style={{ filter: "brightness(0) invert(1)" }} className="mr-2" />
                                        Edit
                                    </button></h1>
                                <div className="formRow">
                                    <div className="formCol">
                                        <div className="form__Field">
                                            <label className="form__uploadProfile" htmlFor="uploadProfile">
                                                {userData?.hospitalDetail?.hospitalLogo ? (<img className="form__uploadProfile__picture" src={userData?.hospitalDetail?.hospitalLogo} alt="" />) : (<img className="form__uploadProfile__picture" src={ICONS.defaultUserIcon} alt="" />)}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <h1 className='form__section__title'>{capitalizeWords(userData?.name)}</h1>
                                <div className='formRow formRow__2'>
                                    <div className='formCol'>
                                        <strong>Contact Details :</strong> {defaultCountryCode} {userData?.contactNumber}
                                        &nbsp;&nbsp;<strong>Email ID :</strong> {userData?.email}
                                    </div>
                                </div>
                            </section>
                            <section className='form__section'>
                                <h1 className='form__section__title'> More Information</h1>
                                {role === _roleType?.government ? (
                                    <>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        User Role
                                                    </label>
                                                    <span>
                                                        {userData?.role ? userData?.role : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Hospital Name
                                                    </label>
                                                    <span>
                                                        {hospitalName ? hospitalName : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Gender
                                                    </label>
                                                    <span>
                                                        {userData?.gender ? userData?.gender : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Date of Birth
                                                    </label>
                                                    <span>
                                                        {userData?.dob ? formatDate(userData?.dob) : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Whatsapp number
                                                    </label>
                                                    <span>
                                                        <span>{userData?.whatsappNumber ? `${defaultCountryCode} ${userData?.whatsappNumber}` : "-"}</span>

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Employee Id
                                                    </label>
                                                    <span>
                                                        {userData?.empId ? userData?.empId : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        User Role
                                                    </label>
                                                    <span>
                                                        {userData?.role ? userData?.role : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Hospital Name
                                                    </label>
                                                    <span>
                                                        {hospitalName ? hospitalName : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        HPR ID
                                                    </label>
                                                    <span>
                                                        {userData?.hprId ? userData?.hprId : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Gender
                                                    </label>
                                                    <span>
                                                        {userData?.gender ? userData?.gender : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Date of Birth
                                                    </label>
                                                    <span>
                                                        {userData?.dob ? formatDate(userData?.dob) : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Department
                                                    </label>
                                                    <span>
                                                        {userData?.department ? userData?.department : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Specialization
                                                    </label>
                                                    <span>
                                                        {userData?.specialization?.length > 0 ? userData?.specialization.map((item, index) =>
                                                            <span key={index}>
                                                                {item}{index < userData.specialization.length - 1 && ", "}
                                                            </span>
                                                        ) : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Years of Experience
                                                    </label>
                                                    <span>
                                                        {userData?.yearsOfExperience ? userData?.yearsOfExperience : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Whatsapp number
                                                    </label>
                                                    <span>
                                                        <span>{userData?.whatsappNumber ? `${defaultCountryCode} ${userData?.whatsappNumber}` : "-"}</span>

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        State Medical Council Registration License Number
                                                    </label>
                                                    <span>
                                                        {userData?.licenseNumber ? userData?.licenseNumber : "-"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Qualification
                                                    </label>
                                                    <span>
                                                        <span>
                                                            {userData?.qualification ? userData?.qualification : "-"}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='formRow formRow__2'>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                <label className="form__label">Availability Slots</label>
                                                <span>
                                                    {userData?.availabilitySlots?.length > 0
                                                    ? userData.availabilitySlots.map((slot, idx) => (
                                                        <div key={idx}>
                                                            {formatTime(slot.from, true)} - {formatTime(slot.to, true)}
                                                        </div>
                                                        ))
                                                    : "-"}
                                                </span>
                                                </div>
                                            </div>
                                            <div className='formCol'>
                                                <div className="form__Field">
                                                    <label className="form__label" htmlFor='name'>
                                                        Day
                                                    </label>
                                                    <span>
                                                        <span>
                                                            {userData?.availabilityDay
                                                                ? (() => {
                                                                    let days = [];
                                                                    if (typeof userData.availabilityDay === 'string') {
                                                                        days = userData.availabilityDay.split(",").map(day => day.trim());
                                                                    } else if (Array.isArray(userData.availabilityDay)) {
                                                                        days = userData.availabilityDay.map(day => day.trim()); // Trim in case of extra spaces
                                                                    }
                                                                    return days.length > 0 ? formatDays(days) : "-";
                                                                })()
                                                                : "-"}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </section>
                            <section className='form__section'>
                                <div className="formRow">
                                    <div className="formCol">
                                        <div className="form__Field">
                                            <div className="cursor-not-allowed opacity-50 relative pointer-events-none">
                                                <SignatureDropzone
                                                    onDrop={() => {}}
                                                    preview={userData?.signature}
                                                    accept={{}}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserDetails
